import createReactComponent from '../createReactComponent';
var Figma = createReactComponent('Figma', [['path', {
  d: 'M5 5.5A3.5 3.5 0 018.5 2H12v7H8.5A3.5 3.5 0 015 5.5z',
  key: 'ddwxp9'
}], ['path', {
  d: 'M12 2h3.5a3.5 3.5 0 110 7H12V2z',
  key: '1mnu7r'
}], ['path', {
  d: 'M12 12.5a3.5 3.5 0 117 0 3.5 3.5 0 11-7 0z',
  key: '14ocg1'
}], ['path', {
  d: 'M5 19.5A3.5 3.5 0 018.5 16H12v3.5a3.5 3.5 0 11-7 0z',
  key: 'l5jib5'
}], ['path', {
  d: 'M5 12.5A3.5 3.5 0 018.5 9H12v7H8.5A3.5 3.5 0 015 12.5z',
  key: '1bbabg'
}]]);
export default Figma;